import { alertController } from '@ionic/core/components';
import { html } from '../lib/html.js';
import { toastError, toastSuccess, withLoading } from '../lib/ui.js';
import { me } from '../services/me.js';
import { reviews } from '../services/reviews.js';
import { Page } from './base.js';
import { reviewCard, summaryBlock } from './review-ui.js';
import { sectionTitle } from './maintenance-ui.js';

/**
 * Avaliações recebidas pela oficina (/oficina/avaliacoes). O responsável responde uma vez (a resposta é pública
 * e o cliente é avisado). A oficina não apaga nem esconde nota: se algo for impróprio, a denúncia vai para o TicketCar.
 */
class WorkshopReviewsPage extends Page {
  template() {
    return html`
      <ion-header translucent>
        <ion-toolbar>
          <ion-buttons slot="start"><ion-back-button default-href="/workshop" text="Voltar"></ion-back-button></ion-buttons>
          <ion-title>Avaliações</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding surface-page" fullscreen>
        <div class="narrow body"></div>
      </ion-content>`;
  }

  setup() {
    this.$('.body').addEventListener('click', (e) => {
      const el = e.target.closest('[data-action="reply"]');
      if (el) this.reply(el.dataset.id);
    });
  }

  onEnter() {
    this.load();
  }

  async load() {
    const body = this.$('.body');
    body.innerHTML = '<div class="center"><ion-spinner></ion-spinner></div>';
    try {
      const r = await reviews.received();
      const manager = me.current?.workshop?.role === 'MANAGER';
      body.innerHTML = html`
        ${r.summary.count
          ? html`${summaryBlock(r.summary)}${r.unanswered ? html`<p class="foot-hint">${r.unanswered} sem resposta. Responder rápido aparece no seu perfil.</p>` : ''}`
          : html`<div class="panel empty-panel"><div class="empty-badge"><ion-icon name="star-outline"></ion-icon></div><strong>Nenhuma avaliação ainda</strong><p>No dia seguinte a cada serviço registrado, o TicketCar pede ao cliente para avaliar. As notas aparecem aqui e no seu perfil.</p></div>`}
        ${r.items.length ? html`${sectionTitle('Mais recentes')}${r.items.map((x) => reviewCard(x, { replyable: manager }))}` : ''}`.value;
    } catch (e) {
      body.innerHTML = html`<div class="center"><p>${e.message}</p></div>`.value;
    }
  }

  async reply(id) {
    const a = await alertController.create({
      header: 'Responder avaliação',
      message: 'A resposta é pública e só pode ser enviada uma vez. Agradeça e, se houve problema, diga o que vai fazer.',
      inputs: [{ name: 'text', type: 'textarea', placeholder: 'Sua resposta', attributes: { maxlength: 500, rows: 4 } }],
      buttons: [{ text: 'Cancelar', role: 'cancel' }, { text: 'Publicar', role: 'confirm' }],
    });
    await a.present();
    const { role, data } = await a.onDidDismiss();
    const text = String(data?.values?.text ?? '').trim();
    if (role !== 'confirm' || text.length < 2) return;
    try {
      await withLoading('Publicando...', () => reviews.reply(id, text));
      toastSuccess('Resposta publicada. O cliente foi avisado.');
      this.load();
    } catch (e) {
      toastError(e.message);
    }
  }
}

customElements.define('page-workshop-reviews', WorkshopReviewsPage);
